import { redirect, createFileRoute } from '@tanstack/react-router';
import { SuperAdminLayout } from '@/pages/layout/SuperAdminLayout';

export const Route = createFileRoute('/_authenticated/super-admin')({
	beforeLoad: ({ context }) => {
		if (context.globalStore.getState().user?.systemCapability !== 'SUPER_ADMIN') {
			throw redirect({ to: '/' });
		}
	},
	component: SuperAdminLayout,
});
